import { useStore } from 'zustand';

import { errorStore } from '../../store/error-store/error-store';
import type { ErrorStore } from '../../types/error-context';

export const useErrorStore = <T>(selector: (store: ErrorStore) => T): T => {
  return useStore(errorStore, selector);
};
